import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button } from '../../../../../../../components'
import { ButtonType } from '../../../../../../../../_metronic/helpers'
import { CondicaoCatalogo } from '../../../../core/condicao/catalogo'
import { Condicao, Grupo, ehGrupo } from '../../../../core/condicao/tipos'
import { ErroPosicionado } from '../../../../core/condicao/caminho'
import { CondicaoGrupo } from './CondicaoGrupo'
import { CampoReferenciavel, LINHA_NOVA } from './tiposEditor'

type Props = {
  /** Condição atual; `null` = campo sempre visível. */
  value: Condicao | null
  /** Campos **anteriores** ao atual, na ordem do formulário. */
  campos: CampoReferenciavel[]
  catalogo: CondicaoCatalogo
  /** Erros do backend ou da validação local, já posicionados na árvore. */
  erros?: ErroPosicionado[]
  disabled?: boolean
  onChange: (condicao: Condicao | null) => void
}

/**
 * Editor da seção "Mostrar este campo quando…".
 *
 * Componente controlado: o valor é sempre o JSON no formato da T8a (tokens ASCII). A raiz é
 * obrigatoriamente um grupo; remover a última linha devolve `null` (campo sempre visível).
 * A tela limita o aninhamento a **um** nível, embora o backend aceite mais.
 */
export const CondicaoEditor: FC<Props> = ({
  value,
  campos,
  catalogo,
  erros = [],
  disabled,
  onChange,
}) => {
  const { t } = useT()

  const semReferencias = campos.length === 0 && catalogo.variaveis.length === 0

  if (!value || !ehGrupo(value)) {
    return (
      <div className='condicao-editor'>
        <p className='text-muted fs-7 mb-3'>{t('formularios.condicao.resumo.sempre')}</p>
        {!disabled && (
          <Button
            type={ButtonType.Button}
            className='btn-secondary'
            size='btn-sm'
            disabled={semReferencias}
            onClick={() => onChange({ todos: [{ ...LINHA_NOVA }] })}
          >
            {t('formularios.condicao.adicionar')}
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className='condicao-editor'>
      <CondicaoGrupo
        grupo={value as Grupo}
        indices={[]}
        campos={campos}
        catalogo={catalogo}
        erros={erros}
        disabled={disabled}
        permiteGrupo
        onChange={(grupo) => onChange(grupo)}
      />
    </div>
  )
}
